<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="B2338, B2442, M1242, MS321, MS421 프린터">
     B2338, B2442, M1242, MS321, MS421 프린터
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_ko" title="안전 정보">
     안전 정보
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="표기 규칙">
      표기 규칙
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e42" title="제품 설명서">
      제품 설명서
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_ko" title="프린터에 대해 알아보기">
     프린터에 대해 알아보기
    </a>
   </p>
   <div id="divd0e179">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_ko" title="프린터에 대한 정보 찾기">
      프린터에 대한 정보 찾기
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_ko" title="프린터 위치 선택">
      프린터 위치 선택
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_ko" title="프린터 구성">
      프린터 구성
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_ko" title="케이블 연결">
      케이블 연결
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_ko" title="제어판 사용">
      제어판 사용
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_ko" title="전원 버튼 및 표시등 상태의 이해">
      전원 버튼 및 표시등 상태의 이해
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_ko" title="용지 및 특수 용지 넣기">
     용지 및 특수 용지 넣기
    </a>
   </p>
   <div id="divd0e736">
    <p class="toc-2-style">
     <a href="setting-size-and-type-of-specialty-media-topic.html#setting-size-and-type-of-specialty-media_ko" title="특수 용지의 크기와 종류 설정">
      특수 용지의 크기와 종류 설정
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-h1-topic.html#configuring-universal-paper-settings-h1_ko" title="Universal 용지 설정 구성">
      Universal 용지 설정 구성
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_ko" title="용지함에 넣기">
      용지함에 넣기
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_ko" title="다용도 급지 장치에 로드">
      다용도 급지 장치에 로드
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_ko" title="용지함 연결">
      용지함 연결
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="supported-paper-sizes-types-and-weights-chapter.html#supported-paper-sizes-types-and-weights-chapter_ko" title="용지 지지대">
     용지 지지대
    </a>
   </p>
   <div id="divd0e929">
    <p class="toc-2-style">
     <a href="supported-paper-sizes-gsm-topic.html#supported-paper-sizes-gsm_ko" title="지원되는 용지 크기">
      지원되는 용지 크기
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-types-gold-topic.html#supported-paper-types-gold_ko" title="지원되는 용지 유형">
      지원되는 용지 유형
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-weights-gsm-topic.html#supported-paper-weights-gsm_ko" title="지원되는 용지 무게">
      지원되는 용지 무게
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_ko" title="사용할 수 없는 용지">
      사용할 수 없는 용지
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_ko" title="재활용 용지 사용">
      재활용 용지 사용
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_ko" title="인쇄">
     인쇄
    </a>
   </p>
   <div id="divd0e1536">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_ko" title="컴퓨터에서 인쇄">
      컴퓨터에서 인쇄
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e1562" title="모바일 장치에서 인쇄">
      모바일 장치에서 인쇄
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_ko" title="글꼴 샘플 목록 인쇄">
      글꼴 샘플 목록 인쇄
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_ko" title="프린터 메뉴 이해">
     프린터 메뉴 이해
    </a>
   </p>
   <div id="divd0e1706">
    <p class="toc-2-style">
     <a href="menus-map-topic.html#menus-map_ko" title="메뉴 맵">
      메뉴 맵
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e1885" title="장치">
      장치
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e2851" title="인쇄">
      인쇄
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e3828" title="용지">
      용지
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e4065" title="네트워크/포트">
      네트워크/포트
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e5545" title="보고서">
      보고서
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-group.html#d0e5674" title="문제 해결">
      문제 해결
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-h1-topic.html#printing-menu-settings-page-h1_ko" title="메뉴 설정 페이지 인쇄">
      메뉴 설정 페이지 인쇄
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_ko" title="프린터 보안">
     프린터 보안
    </a>
   </p>
   <div id="divd0e5728">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_ko" title="보안 슬롯 찾기">
      보안 슬롯 찾기
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_ko" title="프린터 메모리 지우기">
      프린터 메모리 지우기
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_ko" title="공장 출하 시 기본 설정 복원">
      공장 출하 시 기본 설정 복원
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_ko" title="휘발성 메모리 설명">
      휘발성 메모리 설명
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_ko" title="프린터 유지관리">
     프린터 유지관리
    </a>
   </p>
   <div id="divd0e5900">
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e5905" title="네트워킹">
      네트워킹
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_ko" title="프린터 청소">
      프린터 청소
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies.html#ordering-supplies_ko" title="부품 및 소모품 주문">
      부품 및 소모품 주문
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e6526" title="부품 및 소모품 교체">
      부품 및 소모품 교체
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer.html#moving-the-printer_ko" title="프린터 이동">
      프린터 이동
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e6725" title="에너지 및 용지 절약">
      에너지 및 용지 절약
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#d0e6874" title="재활용">
      재활용
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_ko" title="용지 걸림 해결">
     용지 걸림 해결
    </a>
   </p>
   <div id="divd0e6928">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_ko" title="용지 걸림 예방">
      용지 걸림 예방
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_ko" title="용지 걸림 위치 확인">
      용지 걸림 위치 확인
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-door-a-topic.html#paper-jam-in-front-door_ko" title="덮개 A에 걸린 용지">
      덮개 A에 걸린 용지
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-rear-door-topic.html#paper-jam-in-rear-door_ko" title="후면 덮개에 용지 걸림">
      후면 덮개에 용지 걸림
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-standard-bin-topic.html#paper-jam-in-standard-bin_ko" title="표준 출력함의 용지 걸림">
      표준 출력함의 용지 걸림
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-duplex-unit-topic.html#paper-jam-in-duplex-unit_ko" title="양면 인쇄 장치에 용지 걸림">
      양면 인쇄 장치에 용지 걸림
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-trays-topic.html#message-paper-jam-trays_ko" title="용지함의 용지 걸림">
      용지함의 용지 걸림
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-mpf-topic.html#message-paper-jam-mpf_ko" title="다용도 공급 장치에 용지 걸림">
      다용도 공급 장치에 용지 걸림
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_ko" title="문제 해결">
     문제 해결
    </a>
   </p>
   <div id="divd0e7204">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e7207" title="네트워크 연결 문제">
      네트워크 연결 문제
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e7354" title="소모품 관련 문제">
      소모품 관련 문제
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e7500" title="급지 문제">
      급지 문제
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-blank-or-white-pages-topic.html#d0e7886" title="인쇄 문제">
      인쇄 문제
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_ko" title="고객 지원 문의">
      고객 지원 문의
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-and-migrating-chapter.html#upgrading-and-migrating-chapter_ko" title="업그레이드 및 마이그레이션">
     업그레이드 및 마이그레이션
    </a>
   </p>
   <div id="divd0e10238">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e10241" title="하드웨어">
      하드웨어
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e10401" title="소프트웨어">
      소프트웨어
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e10478" title="펌웨어">
      펌웨어
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_ko" title="고지사항">
     고지사항
    </a>
   </p>
   <div id="divd0e10548">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e10551" title="제품 정보">
      제품 정보
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e10568" title="발행 공지">
      발행 공지
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_ko" title="상표">
      상표
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_ko" title="라이센스 관련 고지사항">
      라이센스 관련 고지사항
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_ko" title="음향 배출 수준">
      음향 배출 수준
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e10662" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_ko" title="제품 폐기">
      제품 폐기
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_ko" title="정전기 감도 알림">
      정전기 감도 알림
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_ko" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_ko" title="온도 정보">
      온도 정보
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_ko" title="레이저 고지사항">
      레이저 고지사항
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_ko" title="전력 소비량">
      전력 소비량
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e10880" title="무선 제품에 대한 규제 관련 공지">
      무선 제품에 대한 규제 관련 공지
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_ko" title="모듈식 구성 요소 공지">
      모듈식 구성 요소 공지
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_ko" title="무선 주파수 방사선 노출">
      무선 주파수 방사선 노출
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#korean-kc-statement-2_ko" title="한국 KC 인증서">
      한국 KC 인증서
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue